import * as React from 'react';
import DollarIcon from '@material-ui/icons/AttachMoney';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

const MonthlyRevenue = ({ value }) => {
    const translate = useTranslate();
    return (
        <CardWithIcon
            to="/order"
            icon={DollarIcon}
            title={translate('Monthly Revenue')}
            subtitle={value}
        />
    );
};

export default MonthlyRevenue;
